import { apiClient } from '~/gateway/client'
import type { IPartnersGateway } from './partners.gateway.types'
import type { IUsers } from '~/gateway/users/users.types'

async function get<R extends IUsers.Role>({ slug }: IPartnersGateway.Get.Params) {
  return apiClient<IPartnersGateway.Get.Response<R>>(`/partners/${slug}`)
}

async function getMany<R extends IUsers.Role>(params: IPartnersGateway.GetMany.Params) {
  const query = new URLSearchParams(params as any)
  const queryString = query.toString()
  return apiClient<IPartnersGateway.GetMany.Response<R>>(`/partners${queryString}`)
}

async function create<R extends IUsers.Role>(params: IPartnersGateway.Create.Params<R>) {
  return apiClient<IPartnersGateway.Create.Response<R>>(`/partners`, {
    body: params,
    method: 'POST',
  })
}

async function update<R extends IUsers.Role>({
  partnerId,
  ...body
}: IPartnersGateway.Update.Params) {
  return apiClient<IPartnersGateway.Update.Response<R>>(`/partners/${partnerId}`, {
    body,
    method: 'PATCH',
  })
}

async function updateBilling<R extends IUsers.Role>({
  partnerId,
  billing,
}: IPartnersGateway.UpdateBilling.Params<R>) {
  return apiClient<IPartnersGateway.UpdateBilling.Response<R>>(`/partners/${partnerId}/billing`, {
    body: { ...billing },
    method: 'PATCH',
  })
}

async function remove({ partnerId }: IPartnersGateway.Delete.Params) {
  return apiClient(`/partners/${partnerId}`, {
    method: 'DELETE',
  })
}

async function updateMembers({ partnerId, ...body }: IPartnersGateway.UpdateMembers.Params) {
  return apiClient<IPartnersGateway.UpdateMembers.Response>(`/partners/${partnerId}/members`, {
    body,
    method: 'PATCH',
  })
}

export const PartnersGateway = {
  get,
  update,
  create,
  remove,
  getMany,
  updateMembers,
  updateBilling,
}
